export default "__VITE_ASSET__26ec94c9__"